import React from 'react';
import './Layout.css';

/**
 * Layout component - Container principale dell'applicazione
 * Applica una larghezza massima di 777px a tutto il contenuto
 * e aggiunge padding per evitare sovrapposizioni con la BottomNavigation
 */
const Layout = ({ children }) => {
  return (
    <div className="layout-container">
      <div className="layout-content">
        {children}
      </div>
      {/* Spazio aggiuntivo per evitare che il contenuto venga nascosto dalla barra di navigazione inferiore */}
      <div className="layout-bottom-spacer"></div>
    </div>
  );
};

export default Layout;
